<template>
<div id="contact">
  <section id="contact-message">
    <div class="en">Contact</div>
    <div class="jp">お問い合わせ</div>
    <div v-if="!confFlag && !sendFlag" class="message">
      <span>弊社にご関心をお持ちいただきまして、ありがとうございます。</span>
      <span class="br">お問い合わせ内容の確認後、担当者よりご入力をいただいたメールアドレス宛にご連絡をさせていただきます。</span>
      <span class="br">各項目を入力していただき、入力が終わりましたら、プライバシーポリシーの内容に同意の上、入力内容の確認ボタンを押してください。</span>
    </div>
    <div v-if="confFlag && !sendFlag" class="message">
      <span>以下の入力内容をご確認の上、間違いがなければ「送信する」ボタンを押してください。</span>
      <span class="br">内容を訂正する場合は「戻る」ボタンを押してください。</span>
    </div>
    <div v-if="confFlag && sendFlag" class="message">
      <span>お問い合わせの内容を送信しました。</span>
      <span class="br">ご入力いただきましたメールアドレス宛に、問い合わせ完了メールをお送りさせていただきました。</span>
      <span class="br">後日、担当よりご連絡を差し上げます。</span>
      <span class="br"/>
      <span class="br">問い合わせ完了メールが届いていない場合、大変お手数ですが、お電話にてお問い合わせください。</span>
      <span class="br"/>
      <span class="br">株式会社ビットハイブ</span>
      <span class="br">TEL：03-6811-7716 （窓口営業時間：平日10:30〜19:30）</span>
    </div>
  </section>
  <section id="input-form">
    <div class="wrapper" v-if="!sendFlag">
      <div v-if="!confFlag" class="required">
        <span>必須</span>
      </div>
      <div class="title">
        <span>お問い合わせ内容</span>
      </div>
      <div class="input-value">
        <select v-model="contentOfInquiry" v-if="!confFlag">
          <option disabled value="0">お問い合わせ内容を選択してください</option>
          <option value="1">システム開発支援のご依頼・ご相談</option>
          <option value="2">Web制作のご依頼・ご相談</option>
          <option value="5">採用のお問い合わせ</option>
          <option value="3">取材のご依頼</option>
          <option value="4">その他のお問い合わせ</option>
        </select>
        <span v-if="confFlag && contentOfInquiry == 1">システム開発支援のご依頼・ご相談</span>
        <span v-if="confFlag && contentOfInquiry == 2">Web制作のご依頼・ご相談</span>
        <span v-if="confFlag && contentOfInquiry == 3">採用のお問い合わせ</span>
        <span v-if="confFlag && contentOfInquiry == 4">取材のご依頼</span>
        <span v-if="confFlag && contentOfInquiry == 5">その他のお問い合わせ</span>
      </div>
    </div>
    <div class="wrapper" v-if="contentOfInquiry < 5 && contentOfInquiry != 0 && !sendFlag">
      <div v-if="!confFlag" class="required">
        <span>必須</span>
      </div>
      <div class="title">
        <span>会社名</span>
      </div>
      <div class="input-value">
        <input v-if="!confFlag" v-model="companyName" placeholder="ex) 株式会社ビットハイブ">
        <span v-if="confFlag">{{companyName}}</span>
      </div>
    </div>
    <div class="wrapper" v-if="contentOfInquiry != 0 && !sendFlag">
      <div v-if="!confFlag" class="required">
        <span>必須</span>
      </div>
      <div class="title">
        <span>お名前</span>
      </div>
      <div class="input-value">
        <input v-if="!confFlag" v-model="name" placeholder="ex) 令和 太郎">
        <span v-if="confFlag">{{name}}</span>
      </div>
    </div>
    <div class="wrapper" v-if="contentOfInquiry == 5 && !sendFlag">
      <div v-if="!confFlag" class="required">
        <span>必須</span>
      </div>
      <div class="title">
        <span>年齢</span>
      </div>
      <div class="input-value">
        <input v-if="!confFlag" v-model.number="age" type="number" placeholder="ex) 25">
        <span v-if="confFlag">{{age}}</span>
      </div>
    </div>
    <div class="wrapper" v-if="contentOfInquiry != 0 && !sendFlag">
      <div v-if="!confFlag" class="required">
        <span>必須</span>
      </div>
      <div class="title">
        <span>メールアドレス</span>
      </div>
      <div class="input-value">
        <input v-if="!confFlag" v-model="mail" placeholder="ex) reiwa@example.com">
        <span v-if="confFlag">{{mail}}</span>
      </div>
    </div>
    <div class="wrapper" v-if="contentOfInquiry != 0 && !sendFlag">
      <div v-if="!confFlag" class="required">
        <span>必須</span>
      </div>
      <div class="title">
        <span v-if="contentOfInquiry == 1 || contentOfInquiry == 2 || contentOfInquiry == 3">ご依頼・ご相談内容</span>
        <span v-if="contentOfInquiry == 5">志望動機/自己PRなど</span>
        <span v-if="contentOfInquiry == 4">お問い合わせ内容</span>
      </div>
      <div class="input-value">
        <textarea v-if="!confFlag" v-model="message" placeholder="内容を入力してください"></textarea>
        <pre v-if="confFlag">{{message}}</pre>
      </div>
    </div>
    <div class="send-button-area">
      <div v-if="!confFlag && !sendFlag">
        <span class="ng" v-if="!confOkFlag">未入力の項目があります。プライバシーポリシーへの同意、および全ての必須項目を入力しないと確認ボタンは表示されません。</span>
        <span v-if="confOkFlag">
          <router-link :to="{ name: 'privacy', params: {
            value: 'privacy',
            confOkFlag: confOkFlag,
            contentOfInquiry: contentOfInquiry,
            companyName: companyName,
            name: name,
            age: age,
            mail: mail,
            message: message
          }}">プライバシーポリシー</router-link>
          を一読のうえ、同意後に確認画面へお進みください。</span>
      </div>
      <div v-if="privacyOkFlag && confOkFlag && !confFlag && !sendFlag" class="button-area">
        <button v-on:click="confFlag = true; toTop()">入力内容を確認する</button>
      </div>
      <div v-if="privacyOkFlag && confFlag && !sendFlag" class="button-area">
        <button v-on:click="submit(); toTop()">送信する</button>
      </div>
      <div v-if="confFlag || sendFlag" class="button-area">
        <button class="return" v-on:click="confFlag = false; sendFlag = false; toTop()">戻る</button>
      </div>
    </div>
  </section>
</div>
</template>

<script>
export default {
  name: 'Contact',
  data () {
    return {
      sendFlag: false,
      confFlag: false,
      confOkFlag: false,
      privacyOkFlag: false,
      contentOfInquiry: '0',
      companyName: '',
      name: '',
      age: '',
      mail: '',
      message: ''
    }
  },
  mounted () {
    if (this.$route.params.value != null) {
      document.getElementById(this.$route.params.value).scrollIntoView()
      window.scrollBy(0, -58)
    }
    this.sendFlag = false
    this.confFlag = false
    if (this.$route.params.from === 'privacy') {
      if (this.$route.params.confOkFlag) {
        this.confOkFlag = true
        this.privacyOkFlag = true
      }
      if (this.$route.params.contentOfInquiry != null) {
        this.contentOfInquiry = this.$route.params.contentOfInquiry
      }
      if (this.$route.params.companyName != null) {
        this.companyName = this.$route.params.companyName
      }
      if (this.$route.params.name != null) {
        this.name = this.$route.params.name
      }
      if (this.$route.params.age != null) {
        this.age = this.$route.params.age
      }
      if (this.$route.params.mail != null) {
        this.mail = this.$route.params.mail
      }
      if (this.$route.params.message != null) {
        this.message = this.$route.params.message
      }
      this.$route.params.from = null
    } else {
      if (this.$route.params.from === 'recruit') {
        this.contentOfInquiry = '5'
      } else if (this.$route.params.from === 'home-finance') {
        this.contentOfInquiry = '1'
      } else if (this.$route.params.from === 'home-web-create') {
        this.contentOfInquiry = '2'
      } else {
        this.contentOfInquiry = '0'
      }
      this.confOkFlag = false
      this.privacyOkFlag = false
      this.companyName = ''
      this.name = ''
      this.age = ''
      this.mail = ''
      this.message = ''
    }
  },
  watch: {
    contentOfInquiry: function (val) {
      this.checkValue(val)
    },
    companyName: function () {
      this.checkValue(this.contentOfInquiry)
    },
    name: function () {
      this.checkValue(this.contentOfInquiry)
    },
    age: function () {
      this.checkValue(this.contentOfInquiry)
    },
    mail: function () {
      this.checkValue(this.contentOfInquiry)
    },
    message: function () {
      this.checkValue(this.contentOfInquiry)
    }
  },
  methods: {
    toTop: function () {
      global.$('html, body').animate({scrollTop: 0}, 'fast')
    },
    checkValue: function (val) {
      switch (val) {
        case '0':
          this.confOkFlag = false
          break
        case '1':
        case '2':
        case '3':
        case '4':
          if (!this.companyName) {
            this.confOkFlag = false
            return
          }
          if (!this.name) {
            this.confOkFlag = false
            return
          }
          if (!this.mail) {
            this.confOkFlag = false
            return
          }
          if (!this.message) {
            this.confOkFlag = false
            return
          }
          this.confOkFlag = true
          break
        case '5':
          if (!this.name) {
            this.confOkFlag = false
            return
          }
          if (!this.age) {
            this.confOkFlag = false
            return
          }
          if (!this.mail) {
            this.confOkFlag = false
            return
          }
          if (!this.message) {
            this.confOkFlag = false
            return
          }
          this.confOkFlag = true
          break
      }
    },
    submit: function () {
      let params = new URLSearchParams()

      switch (this.contentOfInquiry) {
        case '1':
          params.append('contentOfInquiry', 'システム開発支援のご依頼・ご相談')
          break
        case '2':
          params.append('contentOfInquiry', 'Web制作のご依頼・ご相談')
          break
        case '3':
          params.append('contentOfInquiry', '取材のご依頼')
          break
        case '4':
          params.append('contentOfInquiry', 'その他のお問い合わせ')
          break
        case '5':
          params.append('contentOfInquiry', '採用のお問い合わせ')
          break
      }
      params.append('companyName', this.companyName)
      params.append('name', this.name)
      params.append('age', this.age)
      params.append('mail', this.mail)
      params.append('message', this.message)

      let vm = this
      this.$axios.post('https://bithive.co.jp/api/mail.php', params)
        .then(function (response) {
          vm.contentList = response.data
        })
        .catch(function (error) {
          console.log(error)
        })

      this.sendFlag = true
    }
  }
}
</script>

<style lang="scss">
@import "../assets/style/global.scss";

#contact {
  @media screen and (min-width: 1025px) {
    padding: 0 70px;
  }
  > #contact-message {
    text-align: left;
    letter-spacing: .15em;
    > .en {
      font-weight: 700;
      font-size: 28px;
      margin: 20px 0 10px 20px;
    }
    > .jp {
      font-size: 11px;
      margin: 20px 0 10px 10px;
    }
    > .en, .jp {
      display: inline-block;
    }
    > .message {
      text-align: justify;
      text-justify: inter-ideograph;
      line-height: 30px;
      margin: 20px;
    }
  }
  > #input-form {
    text-align: left;
    padding: 20px;
    > .wrapper {
      padding: 15px 0;
      border-bottom: solid 1px #CCCCCC;
      > .required, > .title {
        @media screen and (max-width: 1024px) {
          vertical-align: center;
        }
        @media screen and (min-width: 1025px) {
          vertical-align: top;
        }
        margin: 15px 0;
        font-weight: 700;
        display: inline-block;
        letter-spacing: .15em;
      }
      > .required {
        display: inline-block;
        background-color: #d40000;
        color: white;
        font-size: 10px;
        padding: 4px 10px 4px 10px;
        margin: 0 10px 0 0;
        border-radius: 2px;
      }
      > .title {
        @media screen and (min-width: 1025px) {
          width: 220px;
          margin: 0 !important;
        }
      }
      > .input-value {
        @media screen and (max-width: 1024px) {
          display: block;
        }
        @media screen and (min-width: 1025px) {
          display: inline-block;
        }
        > input {
          height: 50px;
        }
        > select {
          height: 50px;
        }
        > textarea {
          height: 200px;
        }
        > select, input, textarea {
          @media screen and (max-width: 1024px) {
            width: 100%;
          }
          @media screen and (min-width: 1025px) {
            width: 500px !important;
          }
          border: none;
          -webkit-border-radius: 5px;
          -moz-border-radius: 5px;
          border-radius: 5px;
          padding: 10px;
          font-size: 14px;
          background-color: #f3f3f3;
        }
        > pre {
          font-family: $font-family;
          margin: 0 !important;
        }
      }
    }
    > .send-button-area {
      margin: 30px 0;
      text-align: center;
      > div > .ng {
        color: #d40000;
      }
      > div > span > a {
        text-decoration: none;
        color: cornflowerblue;
      }
      > div > span > a:hover {
        opacity: .6;
      }
      > .button-area {
        @media screen and (max-width: 1024px) {
          display: block;
          margin: 20px 0;
        }
        @media screen and (min-width: 1025px) {
          display: inline-block;
          margin: 20px 15px !important;
        }
        > button {
          @media screen and (max-width: 1024px) {
            width: 100%;
          }
          @media screen and (min-width: 1025px) {
            width: 400px !important;
          }
          letter-spacing: .15em;
          cursor: pointer;
          font-size: 14px;
          background-color: limegreen;
          color: white;
          font-weight: 700;
          padding: 15px 0;
          border: none;
          border-radius: 5px;
        }
        > .return {
          border: solid 1px #000 !important;
          background-color: #000 !important;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue